import config from '@/config';
import Cookies from 'js-cookie';
import { SCOPE_SNSAPI_BASE } from '@/constants/wechat';

const wechat = {
    scope() {
        return localStorage.getItem('scope');
    },
    setScope(scope) {
        return localStorage.setItem('scope', scope);
    },
    authorize(redirect, scope = SCOPE_SNSAPI_BASE) {
        Cookies.set('redirect', redirect, { expires: 1 });

        const { appid } = config.wechat;
        const redirectUri = encodeURIComponent(`${location.protocol}//${location.host}/wechat/callback`);

        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=bodyawake#wechat_redirect`;
    },
};

export default wechat;



// WEBPACK FOOTER //
// ./src/wechat.js